/* eslint-disable */
import React, { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import "../../styles/challanlist.css";
import { uploadMarksheetList, uploadRetotalingResultList, resetUploadMarksheetData, uploadCandidateList } from '../actions/applicationStagesAction';
import applicationstagesLabels from '../labels/applicationstages_en.json'

const ImportDataModal = (props) => {

    const { register, formState } = useForm({
        mode: "onChange"
    });
    const { uploadedMarksheetList } = useSelector(
        (state) => state.applicationManagementReducer,
        shallowEqual
    );

    const dispatch = useDispatch();

    const [uploadButtonFlag, setUploadButtonFlag] = useState(false)
    const [saveButtonFlag, setSaveButtonFlag] = useState(false)
    let [file, setFile] = useState("");

    const onChangeImage = (event) => {
        if (event.target.files.length === 0) {
            return
        }
        setFile(event.target.files[0])
        setUploadButtonFlag(true)
    }
    const uploadFile = () => {
        let data = {}
        data.file = file;
        data.action = 'upload'
        if (props && props.type === 'retotaling_upload') {
            dispatch(uploadRetotalingResultList(props.advtNo, data))
        }
        else if (props && props.type === 'candidate_list') {
            dispatch(uploadCandidateList(props.adverId, data))
        }
        else {
            dispatch(uploadMarksheetList(data))
        }

        setUploadButtonFlag(false)
        setSaveButtonFlag(true)
    }
    const cancelModal = () => {

        props.setImportDocumentList(false)
        dispatch(resetUploadMarksheetData())
        setUploadButtonFlag(false)
        setSaveButtonFlag(false)
        setFile("")
    }
    const saveFileList = () => {
        let data = {}
        data.file = file;
        data.action = 'save'
        if (props && props.type === 'retotaling_upload') {
            dispatch(uploadRetotalingResultList(props.advtNo, data))
        }
        else if (props && props.type === 'candidate_list') {
            dispatch(uploadCandidateList(props.advtNo, data))
        }
        else {
            dispatch(uploadMarksheetList(data))
        }

        props.setImportDocumentList(false)

        setSaveButtonFlag(false)
        setFile("")
    }

    const handleInputClick = () => {
        if (file !== "") {

            setUploadButtonFlag(true)
        }
    }

    return (
        <div>
            <Modal size="xl" show={props.showImportDocList} onHide={cancelModal} aria-labelledby="example-modal-sizes-title-lg" backdrop='static'>
                <Modal.Header className="d-flex justify-content-between align-items-center logout_heading">
                    <Modal.Title className=" logout_title">{props && props.type === 'retotaling_upload' ? 'Upload Retotaling Result' : props && props.type === 'candidate_list' ? 'Candidate List' : 'Upload Marksheet List'}
                    </Modal.Title>
                      <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={cancelModal}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <div className="form-group">
                            <div className="input-group">

                                <input type="file" name="image" id="image" className="bg-color" accept=".csv" onChange={(event) => onChangeImage(event)} onClick={handleInputClick} ref={register({ required: true })} />
                                <button type="button" onClick={uploadFile} disabled={!(formState.isValid && uploadButtonFlag)} className="  btn btn-primary custom_button  btn-sm f11 pointer ms-2  ">
                                    {applicationstagesLabels.UploadFile}
                                </button>
                            </div>
                        </div>
                        <div>
                            {uploadedMarksheetList && uploadedMarksheetList.length > 0 ?
                                <table className="table table-bordered table-sm">
                                    <thead>
                                        <tr>
                                            {applicationstagesLabels.marksheetListHeaderContent.map((ele, index) =>
                                                <th scope="col" key={index} className='theadBgColor'>{ele}</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {uploadedMarksheetList && uploadedMarksheetList.map((ele, i) => {
                                            if (ele) {
                                                return (
                                                    <tr>
                                                        <td className="w-10 word-break text-center" >{i + 1}</td>
                                                        <td className="word-break" >{ele.advertisementNo}{"/"}{ele.year}</td>
                                                        <td className="word-break" >{ele.applicationNo}</td>
                                                        <td className="word-break" >{ele.englishFullName}</td>
                                                        <td className="word-break" >{ele.email}</td>
                                                        <td className="word-break" >
                                                            {ele.errorMessage}
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        })}

                                    </tbody>
                                </table> : ""
                            }
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={cancelModal}>{applicationstagesLabels.CANCEL}</button>
                    <button type="button" className=" btn btn-primary custom_button " disabled={!saveButtonFlag} onClick={saveFileList}>{applicationstagesLabels.SAVE}</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ImportDataModal;